import React from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import AssistantPanel from '@interaktiv/volto-ai-editor/components/Assistant/AssistantPanel';
import config from '@plone/volto/registry';
import { lockEditor } from './editorLock';
import './lino.css';

export default function LinoPanel(props) {
  const intl = useIntl();
  const mock = config.settings.aiEditor.client === 'mock';
  const running = useSelector((state) => state.assistant?.running);
  React.useLayoutEffect(() => {
    if (running) return lockEditor();
  }, [running]);
  return (
    <IntlProvider
      locale={intl.locale}
      messages={{
        ...intl.messages,
        Assistant: 'Lino',
        Cancel: 'Stop',
        assistantEmptyHint: 'Changes stay in your draft until you save.',
        ...(mock
          ? {
              assistantSuggestionSection: 'Add a paragraph',
              assistantSuggestionMakeover: 'Show the editing demo',
              assistantSuggestionMove: 'Move this block down',
            }
          : {}),
      }}
    >
      <div className="lino-panel-host">
        {running && (
          <div className="lino-editor-status" role="status">
            Lino is working. Editing resumes when it finishes or you press Stop.
          </div>
        )}
        <AssistantPanel {...props} />
      </div>
    </IntlProvider>
  );
}
